import { LabelOrient, LineStyle, RulerInfo } from '~/src/figure/RulerInfo';
import { number, boolean, partial, string } from 'io-ts';
import { Optic, pdot } from '~/src/base/Optic';

export type RulerInfoMod = Partial<RulerInfo>;

export const RulerInfoMod = partial({
	Visible: boolean,
	ShowBar: boolean,
	BarStyle: LineStyle,
	ShowWhisker: boolean,
	ExtendWhisker: boolean,
	WhiskerStyle: LineStyle,
	Layer: number,
	ShowLabel: boolean,
	LabelLayer: number,
	LabelOrient: LabelOrient,
	LabelPrefix: string,
});

export const _Visible: Optic<RulerInfoMod, boolean|undefined> =
	pdot('Visible');

export const _ExtendWhisker: Optic<RulerInfoMod, boolean|undefined> =
	pdot('ExtendWhisker');

export const _Layer: Optic<RulerInfoMod, number|undefined> =
	pdot('Layer');

export const _LabelLayer: Optic<RulerInfoMod, number|undefined> =
	pdot('LabelLayer');

export const defRulerInfoMod = (): RulerInfoMod => ({});

export const applyRulerInfoMod = (rim: RulerInfoMod) => (ri : RulerInfo) : RulerInfo => ({
	Visible: rim.Visible ?? ri.Visible,
	ShowBar: rim.ShowBar ?? ri.ShowBar,
	BarStyle: rim.BarStyle ?? ri.BarStyle,
	ShowWhisker: rim.ShowWhisker ?? ri.ShowWhisker,
	ExtendWhisker: rim.ExtendWhisker ?? ri.ExtendWhisker,
	WhiskerStyle: rim.WhiskerStyle ?? ri.WhiskerStyle,
	Layer: rim.Layer ?? ri.Layer,
	ShowLabel: rim.ShowLabel ?? ri.ShowLabel,
	LabelLayer: rim.LabelLayer ?? ri.LabelLayer,
	LabelOrient: rim.LabelOrient ?? ri.LabelOrient,
	LabelPrefix: rim.LabelPrefix ?? ri.LabelPrefix,
});
